// 9fbef606107a605d69c0edbcd8029e5d
import { createSelector } from 'reselect';
import { getBrandInCaps } from '@tcp/core/src/utils';
import { COUPON_REDEMPTION_TYPE } from '../../../../../../../services/abstractors/CnC/CartItemTile';
import BagPageSelector from '../../../../BagPage/container/BagPage.selectors';
import { getDisplaySitewideCouponByBrand } from '../../../../../../../reduxStore/selectors/session.selectors';

export const getCouponFetchingState = (state) => {
  return state.CouponsAndPromos && state.CouponsAndPromos.get('isFetching');
};

export const getNeedHelpModalState = (state) => {
  return state.CouponsAndPromos && state.CouponsAndPromos.get('isCouponHelpModalOpen');
};

export const getCouponsFetchTimestamp = (state) => {
  return state.CouponsAndPromos && state.CouponsAndPromos.get('couponsFetchTimestamp');
};

export const getAppliedCouponSuccess = (state) => {
  return state.CouponsAndPromos && state.CouponsAndPromos.get('isCouponStatusAppliedSuccess');
};

export const getNormalCoupons = (state) => {
  return state.CouponsAndPromos && state.CouponsAndPromos.get('normalCoupons');
};

export const getBonusPointsDay = (state) => {
  return state.CouponsAndPromos && state.CouponsAndPromos.get('bonusPointsDay');
};

export const getBonusPointsDayCouponIndex = (state) => {
  return state.CouponsAndPromos && state.CouponsAndPromos.get('bonusPointsDayCouponIndex');
};

export const getCallCouponAction = (state) => {
  return state.CouponsAndPromos && state.CouponsAndPromos.get('shouldCallCouponAction');
};

export const getFromCouponTab = (state) => {
  return state.CouponsAndPromos && state.CouponsAndPromos.get('fromCouponTab');
};

export const getFromApplyCTA = (state) => {
  return state.CouponsAndPromos && state.CouponsAndPromos.get('fromApplyCTA');
};

export const getAppliedExpiredCouponListState = (state) => {
  const list = state.CouponsAndPromos && state.CouponsAndPromos.get('couponsAndOffers');
  return list && list.filter((i) => i.status === 'applied' && i.isExpired);
};

export const getAppliedCouponListState = (state) => {
  const list = state.CouponsAndPromos && state.CouponsAndPromos.get('couponsAndOffers');
  return list && list.filter((i) => i.status === 'applied');
};

export const isCouponApplied = createSelector(getAppliedCouponListState, (appliedCouponList) => {
  return appliedCouponList && appliedCouponList.size > 0;
});

export const getAllRewardsCoupons = (state) => {
  const list = state.CouponsAndPromos && state.CouponsAndPromos.get('couponsAndOffers');
  return (
    list &&
    list.filter(
      (i) =>
        i.redemptionType === COUPON_REDEMPTION_TYPE.LOYALTY ||
        i.originalOfferType === COUPON_REDEMPTION_TYPE.PERKSIMPLICIT ||
        i.originalOfferType === COUPON_REDEMPTION_TYPE.PERKSLOYALTY
    )
  );
};

export const verifyExpiredCoupons = (state) => {
  const list = state.CouponsAndPromos && state.CouponsAndPromos.get('couponsAndOffers');
  let haveExpiredCoupons = false;
  if (list?.size > 0) {
    list.forEach((item) => {
      if (item?.isExpired && item?.isApplied) {
        haveExpiredCoupons = true;
      }
    });
  }
  return haveExpiredCoupons;
};

export const filteredCouponsBasedOnBrand = (promotionData, couponData) => {
  const updatedCouponArray = couponData?.map((couponItem) => {
    const promoData = promotionData[couponItem?.promotionId];
    if (promoData) {
      return {
        ...couponItem,
        brand: promoData?.brand,
      };
    }
    return couponItem;
  });
  const currentSiteId = getBrandInCaps();
  return updatedCouponArray?.filter((item) => {
    return (
      item.status === 'applied' ||
      item.isOnHold === 'true' ||
      ((item.brand === currentSiteId || !item.brand || item.brand === '') &&
        (item.status !== 'applied' || item.isOnHold !== 'true'))
    );
  });
};

export const getAllCoupons = (state) => {
  const promotionData = state.Promotions?.promotionsData;
  const couponData = state.CouponsAndPromos && state.CouponsAndPromos.get('couponsAndOffers');
  const displaySitewideCouponByBrandEnabled = getDisplaySitewideCouponByBrand(state);
  if (promotionData && displaySitewideCouponByBrandEnabled) {
    return filteredCouponsBasedOnBrand(promotionData, couponData);
  }

  return couponData;
};

export const getCouponDetails = (state) => {
  return state.CouponsAndPromos && state.CouponsAndPromos.getIn(['couponDetails']);
};

export const getCouponDetailsError = (state) => {
  return state.CouponsAndPromos && state.CouponsAndPromos.get('couponDetailsError');
};

export const getCouponDetailsLoader = (state) => {
  return state.CouponsAndPromos && state.CouponsAndPromos.get('getCouponDetailsLoader');
};

export const getApplyCouponCSHLoader = (state) => {
  return state.CouponsAndPromos && state.CouponsAndPromos.get('applyCouponCSHLoader');
};

export const getCouponCode = (state) => {
  return state.CouponsAndPromos && state.CouponsAndPromos.get('couponCode');
};

export const getAvailableCouponListState = createSelector(getAllCoupons, (list) => {
  return (
    list && list.filter((i) => i.status === 'available' && (!i.isOnHold || i.isOnHold === 'false'))
  );
});

export const getErrorFromCouponTextBox = (state) => {
  return state.form?.CouponForm?.error;
};

export const getNeedHelpContent = (state) => {
  const needHelpContent = state.CartPageReducer.get('moduleXContent').find(
    (moduleX) =>
      moduleX.name ===
      (BagPageSelector.getNeedHelpContent() && BagPageSelector.getNeedHelpContent().name)
  );
  return needHelpContent && needHelpContent.richText;
};

export const getPlaceCashContent = (state) => {
  const needHelpContent = state.CartPageReducer.get('moduleXContent').find(
    (moduleX) =>
      moduleX.name ===
      (BagPageSelector.getPlaceCashContent() && BagPageSelector.getPlaceCashContent().name)
  );
  return needHelpContent && needHelpContent.richText;
};

export const getCouponInitialFetchingState = createSelector(
  [getAllCoupons, getCouponFetchingState],
  (coupons, fetchingState) => {
    return fetchingState && coupons.size === 0;
  }
);

export const getonHoldCouponListState = (state) => {
  const list = state.CouponsAndPromos && state.CouponsAndPromos.get('couponsAndOffers');
  return list && list.filter((i) => i.isOnHold && i.isOnHold !== 'false');
};

export const getonHoldOrAppliedCouponListState = (state) => {
  const list = state.CouponsAndPromos && state.CouponsAndPromos.get('couponsAndOffers');
  return (
    list && list.filter((i) => i.status === 'applied' || (i.isOnHold && i.isOnHold !== 'false'))
  );
};

export const getAvailableCoupons = (state) => {
  return state?.CouponsAndPromos?.get('couponsAndOffers');
};

export const getAllLastAppliedCoupon = (state) => {
  return state?.CouponsAndPromos?.get('lastAppliedCoupon');
};

export const getLastAppliedCouponData = createSelector(
  getAllLastAppliedCoupon,
  getonHoldOrAppliedCouponListState,
  (lastAppliedCoupon, availableCoupons) => {
    if (lastAppliedCoupon && availableCoupons) {
      return availableCoupons.find(
        (coupon) => coupon.id === lastAppliedCoupon || coupon.promotionId === lastAppliedCoupon
      );
    }
    return {};
  }
);

export const getLastAppliedCoupon = createSelector(
  getLastAppliedCouponData,
  getAllLastAppliedCoupon,
  (lastAppliedCouponData, lastAppliedCoupon) => {
    if (lastAppliedCouponData && lastAppliedCouponData.couponType === 'MULTIUSE') {
      return lastAppliedCoupon;
    }
    return '';
  }
);

export const getOpenCouponDetailModal = (state) => {
  return state?.CouponsAndPromos?.get('openCouponDetailModal');
};

export const getMultiAddCouponLoaderState = (state) => {
  return state.CouponsAndPromos && state.CouponsAndPromos.get('multiAddLoader');
};

export const getMultiAddCouponSucessState = (state) => {
  return state.CouponsAndPromos && state.CouponsAndPromos.get('multiAddSuccess');
};

export const getMultiAddCouponErrorState = (state) => {
  return state.CouponsAndPromos && state.CouponsAndPromos.get('multiAddError');
};
